/*
* Copyright (C) Regione Lombardia
*/
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CoreI18nConfigs } from '@core/configs/i18n.config';
import {
    AnagraficaTipologiaOpera,
    DatalistAnagrafica,
    OperaSecondaria
} from '@models';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { OperaService } from '@shared/services/opera.service';
import { UtilsService } from '@shared/services/utils.service';
import { CurrencyMaskInputMode } from 'ngx-currency';

@Component({
    selector: 'app-toolkit-opera-modal-opera-secondaria',
    templateUrl: './modal-opera-secondaria.component.html',
})
export class ToolkitGestioneOperaModalOperaSecondariaComponent implements OnInit {
    
    @Input() azione: string;
    @Input() canEdit: boolean;
    @Input() params: OperaSecondaria;
    @Input() datalist: DatalistAnagrafica;

    public criteriaForm: FormGroup;
    public tipologiaOperaFiltered: AnagraficaTipologiaOpera[] = [];
    readonly natural = CurrencyMaskInputMode.NATURAL;


    constructor(
        public activeModal: NgbActiveModal,
        private operaService: OperaService,
        private utilsService: UtilsService,
        private fb: FormBuilder,
    ) { }

    ngOnInit() {
        this.criteriaForm = this.fb.group({
            idOpera: this.fb.control(this.operaService.operaSession.idOpera, Validators.required),
            idOperaSecondaria: this.fb.control(null),
            quotaMaxMetri: this.fb.control(null),
            quotaMedMetri: this.fb.control(null),
            quotaMinMetri: this.fb.control(null),
            altezzaMetri: this.fb.control(null),
            lunghezzaMetri: this.fb.control(null),
            larghezzaMetri: this.fb.control(null),
            areaMQ: this.fb.control(null),
            volumeMC: this.fb.control(null),
            note: this.fb.control(null),
            idMaterialeCostruzione: this.fb.control(null),
            idMaterialeRivestimento: this.fb.control(null),
            macroTipologiaOpera: this.fb.control(null),
            idTipologiaOpera: this.fb.control(null),
            // idSponda: this.fb.control(null),
            idFunzionePrevalente: this.fb.control({value: null, disabled: true})
        });
        if (this.params) {
            this.criteriaForm.patchValue(this.params);
        }
        if (!this.canEdit) {
            this.criteriaForm.disable();
        }
        this.searchTipologiaOperaByMacroTipologiaOpera();
    }

    public searchTipologiaOperaByMacroTipologiaOpera() {
        if (this.criteriaForm.value.macroTipologiaOpera === null) {
            this.criteriaForm.controls['idTipologiaOpera'].setValue(null);
            this.criteriaForm.controls['idTipologiaOpera'].disable();
            this.tipologiaOperaFiltered = [];
        } else {
            this.tipologiaOperaFiltered = [...(this.datalist.tipologiaOpera || [])].filter((i: AnagraficaTipologiaOpera) =>
                i.idMacroTipologia.id === this.criteriaForm.value.macroTipologiaOpera
            );
            if (this.canEdit) {
                this.criteriaForm.controls['idTipologiaOpera'].enable();
            }
            /*set funzione prevalente */
            this.criteriaForm.get('idFunzionePrevalente')?.setValue( this.datalist.macroTipologiaOpera?.find(f=> f.id === this.criteriaForm.value.macroTipologiaOpera)?.idFunzionePrevalente);
            
        }
        

    }

    public saveOperaSecondaria() {
        if (this.criteriaForm.invalid) {
            this.utilsService.showError(CoreI18nConfigs.messages.fieldRequired);
            return;
        }
        this.activeModal.close(this.criteriaForm);
    }

}
